jQuery( function ( $ ) {

	function privacy_notice_close( cookiesDecision ) {

		Cookies.set( 'privacy-cookies', cookiesDecision, { expires: 365 } );

		$( '#privacy-notice' ).css( 'display', 'none' );

	}

	if ( Cookies.get( 'privacy-cookies' ) === undefined && navigator.doNotTrack !== '1' && window.doNotTrack !== '1' ) {
		$( '#privacy-notice' ).css( 'display', 'flex' );
	}

	if ( navigator.doNotTrack === '1' || window.doNotTrack === '1' ) {
		Cookies.set( 'privacy-cookies', 'reject', { expires: 1 } );
	}

	$( '#privacy-button-accept' ).on( 'click', function () {
		privacy_notice_close( 'accept' );
	} );

	$( '#privacy-button-reject' ).on( 'click', function () {
		privacy_notice_close( 'reject' );
	} );

} );
